import { Button, FormControl, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import React, { useCallback, useState } from 'react';
import ConversationArea from '../../classes/ConversationArea';
import useCoveyAppState from '../../hooks/useCoveyAppState';
import useMaybeVideo from '../../hooks/useMaybeVideo';

interface Props {
    isOpen: boolean;
    onClose: (() => void);
    curConversation: ConversationArea;
}

/** Once a player fills out the modal, the vote value is added to the conversation area.
 * 
 * @param param0 
 * @returns 
 */
export default function VoteModal({ isOpen, onClose, curConversation }: Props): JSX.Element {
    const { socket } = useCoveyAppState();
    const [proposedMedia, setProposedMedia] = useState<string>("");

    const video = useMaybeVideo();
    if (isOpen) {
        video?.pauseGame();
    }

    const proposeVote = useCallback((event) => {
        event.preventDefault();
        video?.unPauseGame();
        if (proposedMedia) {
            const conversationCopy = curConversation.copy();
            conversationCopy.proposedMedia = proposedMedia;
            if (socket) {
                onClose();
                socket.emit('proposeVote', conversationCopy.toServerConversationArea());
            } else {
                onClose();
            }
        }
    }, [video, proposedMedia, curConversation, onClose, socket]);

    return (<>
        <Modal onClose={() => { onClose(); video?.unPauseGame(); }} isOpen={isOpen} >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Call Vote </ModalHeader>
                <ModalCloseButton />
                <form onSubmit={proposeVote}>
                    <ModalBody pb={6}>
                        <FormControl>
                            <FormLabel htmlFor='vote'>What media would you like to propose?</FormLabel>
                            <Input id='vote' placeholder='Share the link'
                                name='vote' value={proposedMedia} onChange={(e) => setProposedMedia(e.target.value)} />
                        </FormControl>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme='blue' mr={3} onClick={proposeVote}>Call Vote</Button>
                        <Button onClick={() => { onClose(); video?.unPauseGame(); }}>Cancel</Button>
                    </ModalFooter>
                </form>
            </ModalContent>
        </Modal>
    </>);
}